export default {
  lang: 'uk',
  dir: 'ltr',
  common: {
    ok: 'Зберегти',
    cancel: 'Скасування',
    key_backspace: 'Стерти',
    key_del: 'Видалити',
    key_down: 'Донизу',
    key_up: 'Догори',
    more_opts: 'Більше налаштувань',
    url: 'URL',
    width: 'Ширина',
    height: 'Висота'
  },
  misc: {
    powered_by: 'Зроблело з'
  },
  ui: {
    toggle_stroke_tools: 'Показати/сховати інструменти обводу',
    palette_info: 'Натисніть для зміни кольору заливки, Shift-Click змінити обвід',
    zoom_level: 'Зміна масштабу',
    panel_action: 'Клацніть щоб відкрити бокову панель',
    quality: 'Якість:',
    pathNodeTooltip: 'Перетягніть ноду щоб її перемістити. Подвійний-клік по ноді щоб змінити тип сегменту',
    pathCtrlPtTooltip: 'Перетягніть контрольну точку щоб змінити властивості кривої',
    pick_stroke_paint_opacity: 'Оберіть Колір Обводу та Прозорість',
    pick_fill_paint_opacity: 'Оберіть Колір Заливки та Прозорість',
    group_identify_label: 'Група ідентифікаційних міток',
    export_type_label: 'Оберіть тип зображення для експорту:',
    panel: 'Панель'
  },
  properties: {
    id: 'Ідентифікатор елемента',
    fill_color: 'Зміна кольору заливки',
    stroke_color: 'Зміна кольору обводки',
    stroke_style: 'Зміна стилю обводки',
    stroke_width: 'Зміна ширини обводки',
    pos_x: 'Змінити X координату',
    pos_y: 'Змінити Y координату',
    linecap_butt: 'Linecap: Butt',
    linecap_round: 'Linecap: Round',
    linecap_square: 'Linecap: Square',
    linejoin_bevel: 'Linejoin: Bevel',
    linejoin_miter: 'Linejoin: Miter',
    linejoin_round: 'Linejoin: Round',
    angle: 'Зміна кута повороту',
    blur: 'Зміна значення розмиття',
    opacity: 'Зміна прозорості вибраного елемента',
    circle_cx: 'Зміна cx координати кола',
    circle_cy: 'Зміна cy координати кола',
    circle_r: 'Зміна радіуса кола',
    ellipse_cx: 'Зміна cx координати еліпса',
    ellipse_cy: 'Зміна cy координати еліпса',
    ellipse_rx: 'Зміна x радіуса еліпса',
    ellipse_ry: 'Зміна y радіуса еліпса',
    line_x1: 'Зміна початкової x координати лінії',
    line_x2: 'Зміна кінцевої x координати лінії',
    line_y1: 'Зміна початкової y координати лінії',
    line_y2: 'Зміна кінцевої y координати лінії',
    rect_height: 'Зміна висоти прямокутника',
    rect_width: 'Зміна ширини прямокутника',
    corner_radius: 'Зміна Радіусу Кутів прямокутника',
    image_width: 'Зміна ширини зображення',
    image_height: 'Зміна висоти зображення',
    image_url: 'Зміна URL',
    node_x: 'Зміна x координати елемента',
    node_y: 'Зміна y координати елемента',
    seg_type: 'Зміна типу Сегмента',
    straight_segments: 'Пряма',
    curve_segments: 'Крива',
    text_contents: 'Зміна вмісту тексту',
    font_family_label: 'Шрифт:',
    font_family: 'Зміна Сімейстра Шрифтів',
    font_size: 'Зміна Розміру Шрифту',
    bold: 'Жирний текст',
    text_decoration_underline: 'Підкреслений',
    text_decoration_linethrough: 'Перекреслений',
    text_decoration_overline: 'Надкреслений',
    italic: 'Курсив',
    text_anchor_start: 'Вирівняти текст з початку',
    text_anchor_middle: 'Вирівняти текст по середині',
    text_anchor_end: 'Вирівняти текст в кінці',
    text_letter_spacing: 'Зміна міжлітерного інтервалу',
    text_word_spacing: 'Зміна інтервалу між словами',
    text_length: 'Дозволяє вказати ширину простору, у якому буде відображатися текст',
    text_length_adjust: 'Регулювання довжини',
    text_length_adjust_spacing: 'Інтервал',
    text_length_adjust_spacing_and_glyphs: 'Інтервал та Гліфи',
    r_label: 'r',
    x_label: 'x',
    y_label: 'y',
    x1_label: 'x1',
    y1_label: 'y1',
    x2_label: 'x2',
    y2_label: 'y2',
    rx_label: 'rx',
    ry_label: 'ry',
    cx_label: 'cx',
    cy_label: 'cy',
    w_label: 'ш',
    h_label: 'в',
    id_label: 'ідентифікатор',
    class_label: 'клас',
    label: 'етикетка',
    class: 'Клас елемента',
    serif: 'Serif',
    sans_serif: 'Sans-serif',
    cursive: 'Cursive',
    fantasy: 'Fantasy',
    monospace: 'Monospace',
    courier: 'Courier',
    helvetica: 'Helvetica',
    times: 'times',
    prefs_and_content: 'Зберігати параметри та вміст SVG локально',
    prefs_only: 'Зберігати тільки параметри локально',
    no_prefs_or_content: 'Не зберігати параметри або вміст SVG локально',
    jgraduate_pad: 'Пікдладка',
    jgraduate_reflect: 'Відображення',
    jgraduate_repeat: 'Повторення'
  },
  tools: {
    main_menu: 'Головне Меню',
    bkgnd_color_opac: 'Зміна фонового кольору/прозорості',
    connector_no_arrow: 'Без стрілки',
    fitToContent: 'Відповідно до вмісту',
    fit_to_all: 'Відповідно до всього вмісту',
    fit_to_canvas: 'Відповідно до полотна',
    fit_to_layer_content: 'Відповідно до вмісту шару',
    fit_to_sel: 'Відповідно до виділення',
    align_relative_to: 'Вирівняти відносно ...',
    relativeTo: 'відносно до:',
    page: 'сторінка',
    largest_object: 'найбільший обʼєкт',
    selected_objects: 'вибрані обʼєкти',
    smallest_object: 'найменший обʼєкт',
    export_img: 'Експорт',
    import_doc: 'Імпорт SVG',
    align_to_page: 'Вирівняти Елемент за Сторінкою',
    align_bottom: 'Вирівняти Низ',
    align_center: 'Вирівняти Центер',
    align_left: 'Вирівняти Ліво',
    align_middle: 'Вирівняти Центр',
    align_right: 'Вирівняти Право',
    align_top: 'Вирівняти Верх',
    mode_select: 'Вибрати Інструмент',
    mode_fhpath: 'Олівець',
    mode_line: 'Лінія',
    mode_rect: 'Прямокутник',
    mode_square: 'Квадрат',
    mode_fhrect: 'Прямокутник від руки',
    mode_ellipse: 'Еліпс',
    mode_circle: 'Коло',
    mode_fhellipse: 'Еліпс від руки',
    mode_path: 'Шлях',
    mode_text: 'Текст',
    mode_image: 'Зображення',
    mode_zoom: 'Масштаб',
    no_embed: 'ПРИМІТКА. Це зображення не можна вбудувати. Це залежить від шляху до зображення',
    undo: 'Скасувати',
    redo: 'Повторити',
    tool_source: 'Джерело Редагування',
    wireframe_mode: 'Каркасний режим',
    clone: 'Дублювання Елемента(ів)',
    del: 'Видалення Елемента(ів)',
    group_elements: 'Групування Елементів',
    make_link: 'Зробити (гіпер)посиланням',
    set_link_url: 'Установити URL-адресу посилання (залиште порожнім, щоб видалити)',
    to_path: 'Перетворити у Шлях',
    reorient_path: 'Переорієнтувати шлях',
    ungroup: 'Розгрупування Елементів',
    docprops: 'Властивості Документа',
    editor_homepage: 'Домашня сторінка SVG-Edit',
    move_bottom: 'На задній план',
    move_top: 'На передній план',
    node_clone: 'Клонувати Елемент',
    node_delete: 'Видалити Елемент',
    node_link: 'Приєднати Контрольні Точки',
    add_subpath: 'Додати підшлях',
    openclose_path: 'Відкрити/закрити підшлях',
    source_save: 'Застосувати зміни',
    cut: 'Вирізати',
    copy: 'Зкопіювати',
    paste: 'Вставити',
    paste_in_place: 'Вставити на місце',
    delete: 'Видалити',
    group: 'Групувати',
    move_front: 'На передній план',
    move_up: 'Перемістити догори',
    move_down: 'Перемістити донизу',
    move_back: 'На задній план',
    tool_unlink_use: 'Розірвати посилання на еталонний елемент (зробити унікальним)',
    ellipse_circle_tool: 'Еліпс/Коло',
    square_rect_tool: 'Квадрат/Прямокутник',
    remember_this_choice: 'Запамʼятати цей вибір?',
    remember_this_choice_title: 'Якщо ви вирішите не використовувати Storage, запам’ятовуючи цей вибір - URL-адреса зміниться, щоб уникнути повторного запиту.',
    flip_horizontal: 'Відобразити горизонтально',
    flip_vertical: 'Відобразити вертикально'
  },
  layers: {
    layer: 'Шар',
    layers: 'Шари',
    del: 'Видалити Шар',
    move_down: 'Перемістити Шар Донизу',
    new: 'Новий Шар',
    rename: 'Переіменувати Шар',
    move_up: 'Перемістити Шар Догори',
    dupe: 'Дублювати Шар...',
    merge_down: 'Об’єднати з нижнім',
    merge_all: 'Об’єднати Усі',
    move_elems_to: 'Перемістити елементи до:',
    move_selected: 'Перемістити вибрані елементи до іншого шару'
  },
  config: {
    image_props: 'Властивості Зображення',
    doc_title: 'Назва:',
    doc_dims: 'Розміри Полотна',
    included_images: 'Включені Зображення',
    image_opt_embed: 'Вбудовувати дані (локальні файли)',
    image_opt_ref: 'Використовувати посилання на файл',
    editor_prefs: 'Налаштування Редактора',
    language: 'Мова:',
    background: 'Фон редактора',
    editor_img_url: 'URL зображення:',
    editor_bg_note: 'Примітка. Фон не буде збережено разом із зображенням.',
    select_predefined: 'Виберіть:',
    units_and_rulers: 'Одиниці та Лінійки',
    show_rulers: 'Показувати лінійки',
    base_unit: 'Базові одиниці:',
    grid: 'Сітка',
    snapping_onoff: 'Увімкн./Вимкн. прив’язку',
    snapping_stepsize: 'Розмір кроку прив’язки:',
    grid_color: 'Колір Сітки:',
    done: 'Виконано',
    change_xxx_color: 'Зміна xxx кольору',
    pick_paint_opavity: 'Оберіть {{newValue}} Фарбу та Прозорість',
    open_color_picker: 'Натисніть, щоб відкрити палітру кольорів',
    jpicker_title: 'Перетягніть маркери, щоб вибрати колір',
    jpicker_new_color: 'новий',
    jpicker_current_color: 'поточний',
    jpicker_tooltip_colors_new_color: 'Новий Колір - Натисніть &ldquo;OK&rdquo; щоб Підтвердити',
    jpicker_tooltip_colors_current_color: 'Натисніть, щоб повернутися до початкового кольору',
    jpicker_tooltip_buttons_ok: 'Затвердити цей вибір кольору',
    jpicker_tooltip_buttons_cancel: 'Скасувати та повернутися до початкового кольору',
    jpicker_tooltip_hue_radio: 'Встановити режим кольору по &ldquo;Відтінку&rdquo;',
    jpicker_tooltip_hue_textbox: 'Введіть значення &ldquo;Відтінку&rdquo; (0-360&deg;)',
    jpicker_tooltip_saturation_radio: 'Встановити режим кольору по &ldquo;Насиченню&rdquo;',
    jpicker_tooltip_saturation_textbox: 'Введіть значення &ldquo;Насичення&rdquo; (0-100%)',
    jpicker_tooltip_value_radio: 'Встановити режим кольору по &ldquo;Значеню&rdquo;',
    jpicker_tooltip_value_textbox: 'Введіть &ldquo;Значення&rdquo; (0-100%)',
    jpicker_tooltip_red_radio: 'Встановити режим кольору &ldquo;Червоний&rdquo;',
    jpicker_tooltip_red_textbox: 'Введіть значення &ldquo;Червоного&rdquo; (0-255)',
    jpicker_tooltip_green_radio: 'Встановити режим кольору &ldquo;Зелений&rdquo;',
    jpicker_tooltip_green_textbox: 'Введіть значення &ldquo;Зеленого&rdquo; (0-255)',
    jpicker_tooltip_blue_radio: 'Встановити режим кольору &ldquo;Синій&rdquo;',
    jpicker_tooltip_blue_textbox: 'Введіть значення &ldquo;Синього&rdquo; (0-255)',
    jpicker_tooltip_alpha_radio: 'Встановити режим кольору &ldquo;Прозорість&rdquo;',
    jpicker_tooltip_alpha_textbox: 'Введіть значення &ldquo;Прозорості&rdquo; (0-100)',
    jpicker_tooltip_hex_textbox: 'Введіть &ldquo;Hex&rdquo; Значення Кольору (#000000-#ffffff)',
    jpicker_tooltip_hex_alpha: 'Введіть значення &ldquo;Прозорості&rdquo; (#00-#ff)',
    jgraduate_solid_color: 'Суцільний Колір',
    jgraduate_linear_gradient: 'Лінійний Градієнт',
    jgraduate_radial_gradient: 'Радіальний Градієнт',
    jgraduate_begin_point: 'Початкова Точка',
    jgraduate_enter_starting_x: 'Введіть початкове значення x між 0.0 та 1.0',
    jgraduate_enter_starting_y: 'Введіть початкове значення y між 0.0 та 1.0',
    jgraduate_end_point: 'Кінцева Точка',
    jgraduate_enter_ending_x: 'Введіть кінцеве значення x між 0.0 та 1.0',
    jgraduate_enter_ending_y: 'Введіть кінцеве значення y між 0.0 та 1.0',
    jgraduate_center_point: 'Центральна Точка',
    jgraduate_enter_value_x: 'Введіть значення x між 0.0 and 1.0',
    jgraduate_enter_value_y: 'Введіть значення y між 0.0 and 1.0',
    jgraduate_focal_point: 'Точка Фокусу',
    jgraduate_match_center: 'Цент співпадіння:',
    jgraduate_enter_focal_x: 'Введіть значення x між 0.0 and 1.0',
    jgraduate_enter_focal_y: 'Введіть значення y між 0.0 and 1.0',
    jgraduate_spread_method: 'Метод поширення',
    jgraduate_radius: 'Радіус:',
    jgraduate_set_radius: 'Клацніть щоб встановити радіус',
    jgraduate_ellip: 'Еліпс:',
    jgraduate_set_ellip: 'Клацніть щоб встановити Еліпс',
    jgraduate_angle: 'Кут:',
    jgraduate_set_angle: 'Клацніть щоб встановити Кут',
    jgraduate_deg: 'град.:',
    jgraduate_opac: 'Проз.:',
    jgraduate_set_opac: 'Клацніть щоб встановити Прозорість'
  },
  notification: {
    invalidAttrValGiven: 'Вказано недійсне значення',
    noContentToFitTo: 'Немає вмісту, на який можна було б посилатися',
    dupeLayerName: 'Шар із такою назвою вже існує!',
    enterUniqueLayerName: 'Введіть унікальну назву шару',
    enterNewLayerName: 'Введіть назву нового шару',
    layerHasThatName: 'Шар уже має таку назву',
    QmoveElemsToLayer: "Перемістити виділені елементи на шар '%s'?",
    QwantToClear: 'Ви хочете очистити малюнок?\nЦе також зітре історію ваших дій!',
    QwantToOpen: 'Бажаєте відкрити новий файл?\nЦе також зітре історію ваших дій!',
    QerrorsRevertToSource: 'Виявлено помилки парсінгу вашої SVG.\n' +
      'Повернутися до оригінального джерела SVG?',
    QignoreSourceChanges: 'Ігнорувати зміни, внесені до джерела SVG?',
    featNotSupported: 'Функція не підтримується',
    enterNewImgURL: 'Введіть URL-адресу нового зображення',
    defsFailOnSave: 'ПРИМІТКА: через помилку у вашому браузері це зображення може виглядати неправильно (відсутні градієнти або елементи). Однак після фактичного збереження воно буде виглядати правильним.',
    loadingImage: 'Завантаження зображення, зачекайте...',
    saveFromBrowser: 'Виберіть «Зберегти як...» у своєму браузері (через меню «Файл» або контекстне меню, клацнувши правою кнопкою миші), щоб зберегти це зображення як файл {{type}}.',
    noteTheseIssues: 'Також зверніть увагу на такі проблеми: ',
    unsavedChanges: 'Є незбережені зміни.',
    enterNewLinkURL: 'Введіть нову URL-адресу гіперпосилання',
    errorLoadingSVG: 'Помилка: неможливо завантажити дані SVG',
    URLLoadFail: 'Неможливо завантажити з URL',
    retrieving: "Отримання '%s' ...",
    popupWindowBlocked: 'Спливаюче вікно може бути заблоковано браузером',
    exportNoBlur: 'Розмиті елементи відображатимуться як нерозмиті',
    exportNoforeignObject: 'foreignObject елементи не відображатимуться',
    exportNoDashArray: 'Обводки будуть заповнені',
    exportNoText: 'Текст може не виглядати належним чином',
    editorPreferencesMsg: 'За замовчуванням і там, де це підтримується, SVG-Edit може зберігати ваші параметри редактора та вміст SVG локально на вашому комп’ютері, тож вам не потрібно додавати їх щоразу, коли ви завантажуєте SVG-Edit. Якщо з міркувань конфіденційності ви не бажаєте зберігати цю інформацію на своєму комп’ютері, ви можете змінити параметр за замовчуванням нижче.',
    source_dialog_note: 'Скопіюйте вміст цього поля в текстовий редактор, а потім збережіть файл із розширенням .svg.'
  }
}
